module.exports = __webpack_public_path__ + "img/242.a17200bb.jpg";